<template>
    <div class="containnerBox">
        <a-card size="small" title="消息推送">
            <v-gobackbutton slot="extra">返回</v-gobackbutton>
        </a-card>
        <channelSelecter ref="channelS" :isDisabled="false" @onChannelCodeChange="handleChannelChange" style="border-bottom:1px solid #e8e8e8"></channelSelecter>
        <div class="oprationBox">
            <a-card size="small" title="配置推送任务">
                <a-form-model :model="modal" ref="ruleForm" :rules="rules" layout="vertical">
                    <a-form-model-item label="选择推送通道" ref="passwaytype" prop="passwaytype">
                        <passwaySelecter :channelcode="modal.channelcode" @onPasswayCodeChange="handlePasswayChange" style="margin-left:10px;"></passwaySelecter>
                    </a-form-model-item>
                    <a-form-model-item ref="messageservicecode" label="选择业务类型" prop="messageservicecode">
                        <messageServiceSelecter :showAll="false" :channelcode="modal.channelcode" @onmessageserviceCodeChange="handleMessageServiceChange" style="margin-left:10px;"></messageServiceSelecter>
                    </a-form-model-item>

                    <a-form-model-item label="设置发送时间" ref="messagesendtype" prop="messagesendtype">
                        <a-radio-group v-model="modal.messagesendtype">
                            <a-radio value="01">
                                立即
                            </a-radio>
                            <a-radio value="02">
                                定时
                            </a-radio>
                        </a-radio-group>
                    </a-form-model-item>

                    <a-form-model-item label="" v-if="modal.messagesendtype == '02'" :validate-status="timeValidate" :help="validateMsg" ref="messagesendtime" prop="messagesendtime">
                        <a-date-picker :disabled-date="disabledDate" show-time placeholder="选择发送时间" v-model="modal.messagesendtime" />
                    </a-form-model-item>

                    <a-form-model-item label="设置推送目标" ref="receivertype" prop="receivertype">
                        <!-- 站内信 -->
                        <a-radio-group v-model="modal.receivertype" v-if="modal.passwaytype == 'PASSTYPE-001'">
                            <a-radio value="01">
                                广播所有人
                            </a-radio>
                            <a-radio value="02">
                                标签(Tag)
                            </a-radio>
                            <a-radio value="03">
                                用户ID
                            </a-radio>
                            <a-radio value="04">
                                业务编码（商户编码或服务商）
                            </a-radio>
                            <a-radio value="05">
                                商户-门店-用户
                            </a-radio>
                        </a-radio-group>
                        <!-- APP推送 -->
                        <a-radio-group v-model="modal.receivertype" v-if="modal.passwaytype == 'PASSTYPE-002'">
                            <a-radio value="01">
                                广播所有人
                            </a-radio>
                            <a-radio value="02">
                                极光标签(Tag)
                            </a-radio>
                        </a-radio-group>
                        <!-- WebSocket推送 -->
                        <a-radio-group v-model="modal.receivertype" v-if="modal.passwaytype == 'PASSTYPE-003'">
                            <a-radio value="01">
                                广播所有人
                            </a-radio>
                            <a-radio value="02">
                                商户-门店
                            </a-radio>
                            <a-radio value="03">
                                用户ID
                            </a-radio>
                            <a-radio value="04">
                                设备编号
                            </a-radio>
                            <a-radio value="05">
                                商户-门店-用户
                            </a-radio>
                        </a-radio-group>
                        <!-- 邮件 -->
                        <a-radio-group v-model="modal.receivertype" v-if="modal.passwaytype == 'PASSTYPE-009'">
                            <a-radio value="01">
                                广播所有人
                            </a-radio>
                            <a-radio value="02">
                                标签(Tag)
                            </a-radio>
                            <a-radio value="03">
                                用户ID
                            </a-radio>
                            <a-radio value="06">
                                邮件地址
                            </a-radio>
                        </a-radio-group>
                        <!-- 钉钉 -->
                        <a-radio-group v-model="modal.receivertype" v-if="modal.passwaytype == 'PASSTYPE-010'">
                            <a-radio value="01">
                                广播所有人
                            </a-radio>
                            <a-radio value="02">
                                标签(Tag)
                            </a-radio>
                            <a-radio value="03">
                                用户ID
                            </a-radio>
                            <a-radio value="06">
                                钉钉群或手机号
                            </a-radio>
                        </a-radio-group>

                    </a-form-model-item>
                    <a-form-model-item v-if="modal.receivertype != '01'" ref="receivervalueArray" prop="receivervalueArray">
                        <div class="typeBox bordered">
                            <div style="padding:10px">
                                <a-radio-group v-model="suserType">
                                    <a-radio value="1">
                                        手动输入
                                    </a-radio>
                                    <a-radio value="2">
                                        文件上传
                                    </a-radio>
                                </a-radio-group>
                            </div>
                            <div class="fileBox" v-if="suserType == '1'">
                                <a-select mode="tags" v-model="modal.receivervalueArray" placeholder="添加推送目标，并按Enter 键继续">
                                </a-select>
                            </div>

                            <div v-if="suserType == '2'" class="fileBox">
                                <div class="fileinBox">
                                    <a href="javascript:;" class="file">选择文件
                                        <input type="file" @change="fileHandleChange" accept="text/plain">
                                    </a>
                                    <div class="filecount" :style="{color:modal.receivervalueArray.length > 0 ? 'green' : ''}">已选择 {{modal.receivervalueArray.length}}</div>
                                </div>
                                <p>请上传txt类型的文件；文件最大为2kb；文件内容为utf-8编码方式；每行一个推送目标</p>
                            </div>
                        </div>

                    </a-form-model-item>

                    <a-form-model-item label="通知标题" ref="messagetitle" prop="messagetitle">
                        <a-input v-model="modal.messagetitle" />
                    </a-form-model-item>

                    <a-form-model-item label="消息内容" ref="messageecontent" prop="messageecontent">
                        <div class="typeBox bordered">
                            <div style="padding:10px">
                                <a-radio-group v-model="contentType">
                                    <a-radio value="1">
                                        普通文本
                                    </a-radio>
                                    <a-radio value="2">
                                        富文本
                                    </a-radio>
                                </a-radio-group>
                            </div>
                            <div class="fileBox" v-if="contentType == '1'">
                                <a-input v-model="modal.messageecontent" type="textarea" :rows="8" />
                            </div>
                            <div v-if="contentType == '2'" class="fileBox">
                                <QEditor :height="800" v-model="modal.messageecontent"></QEditor>
                            </div>
                        </div>

                    </a-form-model-item>

                    <a-form-model-item ref="messageextras" label="附加参数（JSON格式）" prop="messageextras">
                        <a-input v-model="modal.messageextras" type="textarea" :rows="8" />
                    </a-form-model-item>

                </a-form-model>

            </a-card>
            <div style="display:block;margin:24px auto;width:200px;">
                <!-- :loading="confirmLoading" -->
                <a-button type="primary" @click="handleOk" :loading="confirmLoading">
                    确认推送
                </a-button>

                <a-button @click="handleCancel" style="margin-left:10px;">
                    取消
                </a-button>
            </div>

        </div>
    </div>

</template>
<script>
import channelSelecter from '../../components/channelSelecter'
import passwaySelecter from '../../components/passwaySelecter'
import messageServiceSelecter from '../../components/messageServiceSelecter'
import QEditor from '@/components/QEditor/QEditor'

export default {
    data() {
        return {
            confirmLoading: false,
            modal: {
                channelcode: '',
                messageservicecode: '',
                messagetitle: '',
                messageecontent: '',
                passwaytype: '',
                receivertype: '01',
                messagesendtype: '01',
                receivervalue: '',
                messagesendtime: '',
                messageextras: '',
                receivervalueArray: [],
            },
            timeValidate: 'success',
            suserType: '1',
            contentType: '1',
            rules: {
                passwaytype: [
                    { required: true, message: '请选择通道', trigger: 'blur' },
                ],
                messageservicecode: [
                    {
                        required: true,
                        message: ' 请选择业务类型',
                        trigger: 'blur',
                    },
                ],
                messagesendtype: [
                    {
                        required: true,
                        message: ' 请设置发送时间',
                        trigger: 'blur',
                    },
                ],
                messagesendtime: [
                    {
                        required: true,
                        message: ' 请设置发送时间',
                        trigger: 'blur',
                    },
                ],
                receivertype: [
                    {
                        required: true,
                        message: ' 请设置推送目标',
                        trigger: 'blur',
                    },
                ],
                messagetitle: [
                    {
                        required: true,
                        message: ' 请输入通知标题',
                        trigger: 'blur',
                    },
                ],
                messageecontent: [
                    {
                        required: true,
                        message: ' 请输入消息内容',
                        trigger: 'blur',
                    },
                ],
                receivervalueArray: [
                    {
                        required: true,
                        message: ' 请录入推送目标',
                        trigger: 'blur',
                    },
                ],
            },
        }
    },
    methods: {
        handleMessageServiceChange(ser) {
            this.modal.messageservicecode = ser.messageservicecode
        },
        handlePasswayChange(v) {
            this.modal.passwaytype = v.passwaytype
        },
        handleOk() {
            let that = this
            that.$refs.ruleForm.validate((valid) => {
                // 校验推送目标
                let messagesendtype = that.modal.messageservicecode
                let receivervalueArray = that.modal.receivervalueArray
                if ('01' != messagesendtype) {
                    if (!receivervalueArray || receivervalueArray.length == 0) {
                        return false
                    }
                    that.modal.receivervalue = receivervalueArray.join(',')
                } else {
                    that.modal.receivervalue = ''
                }
                let req = {}
                req.channelcode = that.modal.channelcode
                req.messageservicecode = that.modal.messageservicecode
                req.messagetitle = that.modal.messagetitle
                req.messageecontent = that.modal.messageecontent
                req.passwaytype = that.modal.passwaytype
                req.receivertype = that.modal.receivertype
                req.messagesendtype = that.modal.messagesendtype
                req.receivervalue = that.modal.receivervalue
                req.messagesendtime = that.modal.messagesendtime
                req.messageextras = that.modal.messageextras
                if (valid) {
                    this.confirmLoading = true
                    //新增
                    this.$store
                        .dispatch({
                            type: 'mcmsmanager/savemessageapi',
                            params: {
                                ...req,
                            },
                        })
                        .then((response) => {
                            if (response.data.success == '1') {
                                // this.message.success('发送成功！！')
                                this.handleCancel()
                            }
                            this.confirmLoading = false
                        })
                        .catch(() => {
                            this.confirmLoading = false
                        })
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        handleChannelChange(item) {
            this.modal.channelcode = item.value
        },
        handleCancel() {
            let that = this
            that.modal.messagetitle = ''
            that.modal.messageecontent = ''
            that.modal.receivertype = '01'
            that.modal.messagesendtype = '01'
            that.modal.receivervalue = ''
            that.modal.messagesendtime = ''
            that.modal.messageextras = ''
            that.modal.receivervalueArray = []
        },
        fileHandleChange(e) {
            const file = e.target.files[0]
            if (file) {
                var fileSize = file.size
                if (fileSize <= 2000) {
                    const reader = new FileReader()
                    reader.onload = (e) => {
                        this.handleFileText(e.target.result)
                    }
                    reader.readAsText(file)
                } else {
                    this.message.error('文件过大')
                }
            }
        },
        handleFileText(str) {
            this.receivervalueArray = str.split('\r\n')
        },
    },
    components: {
        channelSelecter,
        passwaySelecter,
        messageServiceSelecter,
        QEditor,
    },
    mounted() {
        this.modal.channelcode = this.$refs.channelS.value
    },
}
</script>
<style scoped>
.items {
    display: flex;
    justify-content: center;
    margin-top: 120px;
}

.itemCard {
    padding: 34px 28px;
    text-align: center;
    width: 240px;
    margin: 20px;
}

.itemCard img {
    margin-bottom: 10px;
}

.itemTitle {
    font-weight: bolder;
    color: #000;
    margin-bottom: 12px;
}

.itemContent {
    color: rgba(0, 0, 0, 0.5);
    margin-bottom: 24px;
}

.oprationBox {
    padding: 30px 28px 0 28px;
}

.typeBox {
    margin: 20px 0;
}

.bordered {
    border: 1px solid lightgray;
}
.fileBox {
    width: 100%;
    padding: 18px;
    border-top: 1px solid lightgray;
    margin-top: 10px;
}

.file {
    position: relative;
    float: left;
    width: 84px;
    margin: 10px 5px;
    cursor: pointer;
    background: #d0eeff;
    border: 1px solid #99d3f5;
    border-radius: 4px;
    padding: 4px 12px;
    overflow: hidden;
    color: #1e88c7;
    text-decoration: none;
    text-indent: 0;
    line-height: 20px;
}
.file input {
    position: absolute;
    font-size: 100px;
    right: 0;
    top: 0;
    opacity: 0;
    cursor: pointer;
}
.file:hover {
    background: #aadffd;
    border-color: #78c3f3;
    color: #004974;
    text-decoration: none;
}

.filecount {
    position: relative;
    margin: 14px 20px;
    float: left;
}
.fileinBox {
    width: 100%;
    float: left;
}
</style>


